import { DeliveryRateResponse } from '../types/delivery-rate.types';
import { instance } from './instance';

export const getAllDeliveryRates = async (): Promise<
  DeliveryRateResponse[]
> => {
  const { data } = await instance.get('/delivery-rate/all/');
  return data.data;
};

export const createDeliveryRate = async (
  payload: Omit<DeliveryRateResponse, 'id' | 'createdAt' | 'updatedAt'>
): Promise<DeliveryRateResponse> => {
  const { data } = await instance.post('/admin/delivery-rate/create/', payload);
  return data.data;
};
